import React from 'react';
import type { CrudAddModalProps } from '../crud/CrudTable';
import type { ProductPodcastFragment } from '../../graphql/graphql';
import { usePodcastService } from '../../services/PodcastService';
import AddProductAssociationModal from '../shared/AddProductAssociationModal';

export type AddProductPodcastModalProps = CrudAddModalProps<ProductPodcastFragment, ProductPodcastFragment> & {
	podcastId: string;
	excludeIds?: string[];
};

export default function AddProductPodcastModal(props: AddProductPodcastModalProps) {
	const { podcastId, onCreated, excludeIds, ...modalProps } = props;
	const podcastService = usePodcastService();

	const handleCreated = (created: ProductPodcastFragment | ProductPodcastFragment[]) => {
		if (Array.isArray(created)) {
			created.forEach((createdItem) => onCreated(createdItem));
		} else {
			onCreated(created);
		}
	};

	const handleAddProduct = async (entityId: string, productIds: string | string[]) => {
		if (Array.isArray(productIds)) {
			return await podcastService.addProductPodcasts(
				productIds.map((productId) => ({
					podcastId: entityId,
					productId,
				})),
			);
		}

		return await podcastService.addProductPodcast({
			podcast: {
				connect: {
					id: entityId,
				},
			},
			product: {
				connect: {
					id: productIds,
				},
			},
		});
	};

	return (
		<AddProductAssociationModal
			{...modalProps}
			entityId={podcastId}
			onAddProduct={handleAddProduct}
			onCreated={handleCreated}
			errorMessage="Failed to add product to podcast"
			excludeIds={excludeIds}
			multiple
		/>
	);
}
